import { Employee } from "@/model/entity/employee/employee"
import { ApplicationEntity } from "@/model/entity/application-entity"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity//field-descriptor"
import { Expose, Type } from "class-transformer"
import ACTIVITY_TYPE from "./activity-type"
import moment from "moment"
import { ExportLogService } from "@/model/service/activity-history/export-log-service"
import CollectionRequestExportLog from "./collection-request-export-log"
import PacelExportLog from "./parcel-export-log"
import AddressExportLog from "./address-export-log"

class ActivityHistory extends ApplicationEntity {

    @FieldDescriptor({
      fieldType: FieldTypeEnum.NUMBER,
      fieldPrettyName: "general.id"
    })
    public id: number | null = null

    @Expose()
    @FieldDescriptor({
      fieldType: FieldTypeEnum.DATE,
      hasTime: true,
      fieldPrettyName: "activity-history.date"
    })
    public creationDate: Date | null = null

    public get dateAndTime() {
      return moment(this.creationDate).format("DD.MM.YYYY HH:mm:ss")
    }

    @Type(() => Employee)
    public employee: Employee | null = null

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "activity-history.username"
    })
    get user(): string {
      return this.employee.username
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "activity-history.activity_type"
    })
    public activityTypeEnum: ACTIVITY_TYPE

    public isExportAvailable() {
      return [
        ACTIVITY_TYPE.ADDRESS_EXPORT,
        ACTIVITY_TYPE.COLLECTION_REQUEST_EXPORT,
        ACTIVITY_TYPE.PARCEL_EXPORT
      ].includes(this.activityTypeEnum)
    }

    public getExportLogService() {
      let service = null
      switch (this.activityTypeEnum) {
        case ACTIVITY_TYPE.COLLECTION_REQUEST_EXPORT:
          service = new ExportLogService(CollectionRequestExportLog, this)
          break
        case ACTIVITY_TYPE.PARCEL_EXPORT:
          service = new ExportLogService(PacelExportLog, this)
          break
        case ACTIVITY_TYPE.ADDRESS_EXPORT:
          service = new ExportLogService(AddressExportLog, this)
          break
      }

      return service
    }

    constructor(
        activityTypeEnum: ACTIVITY_TYPE,
        creationDate: Date,
        id?: number
    ) {
        super(id)
        this.creationDate = creationDate
        this.activityTypeEnum = activityTypeEnum
    }
}

export default ActivityHistory
